import React, { useEffect, useState, useRef } from 'react';
import BookcluosureNav from './BookcluosureNav';
// import Button from '@mui/material/Button';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getBCEntries } from '../../redux/actions/BookClosure/actionBookClosure';
import { getOneBookClosure, savePreset } from '../Services/ApiHandler';
import swal from "sweetalert";
import GetPresetNameModal from '../Components/GetPresetNameModal';
import { toast } from 'react-toastify';
import { motion } from "framer-motion";

import { formatAmount } from "../../utils/formatAmount";
import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import CreatePackageModal from "../../myfin_v2/components/bookclosure/CreatePackageModal";
import { Button } from "../../myfin_v2/elements/Button";


const BookClosureEntries = () => {
    const { workspaceId, companyId } = useParams();
    const dispatch = useDispatch();
    const [selectedEntries, setSelectedEntries] = useState([]);
    const [createPackageModal, setCreatePackageModal] = useState(false);

    const [name, setName] = useState("");
    const [savePresetModal, setSavePresetModal] = useState(false);
    const [isSavePresetLoading, setIsSavePresetLoading] = useState(false);

    const [disableEntries, setDisableEntries] = useState([]);
    const headerCheckboxRef = useRef();


    const {
        bookClosureId,
        entries,
        sceLoading,
        bceErrorMessage,
        bceApiFetched
    } = useSelector((state) => state.BookClosureReducer);


    useEffect(() => {
        getBookClosureData();
        // if (!bceApiFetched) {
            dispatch(getBCEntries(bookClosureId, companyId));
        // }
    }, [workspaceId, companyId]);

    useEffect(() => {
        if (headerCheckboxRef.current) {
            headerCheckboxRef.current.indeterminate =
                selectedEntries.length > 0 && selectedEntries.length < entries.length;
        }
    }, [selectedEntries, entries]);

    const getBookClosureData = () => {
        const data = {
            // companies: [],
            // assignees: [],
            // approvers: [userId]
        }
        if (!bookClosureId) {
            getOneBookClosure(workspaceId, data).then(response => {
                dispatch({ type: "BOOK_cLOSURE_DATA", payload: response.data.bookClosure || {} });
                const book_closure_id = response.data.bookClosure._id;
                if (book_closure_id) {
                    dispatch(getBCEntries(book_closure_id, companyId));
                }
            }).catch(error => {
                swal("Error", `Book Closure Error: ${error.response?.data?.error}`, 'error');
            })
        }
    }

    const SaveAsPreset = () => {
        setIsSavePresetLoading(true);
        savePreset({
            name,
            bookClosureID: bookClosureId,
            companyID: companyId
        }).then(response => {
            setSavePresetModal(false);
            setName("");
            toast.success("Preset saved successfully.")
        }).catch(error => {
            swal("Error", `Save Preset Error: ${error.response?.data?.error}`, 'error');
        }).finally(() => setIsSavePresetLoading(false))
    }

    const handleEntryToggle = (entry) => {
        setSelectedEntries(prev => {
            const alreadySelected = prev.some(e => e.taskID === entry.taskID);
            if (alreadySelected) {
                return prev.filter(e => e.taskID !== entry.taskID);
            } else {
                return [...prev, { taskID: entry.taskID, ledgersData: entry.addedLedgers }];
            }
        });
    };

    const handleToggleAll = () => {
        if (!entries || entries.length === 0) return;

        if (selectedEntries.length === entries.length) {
            setSelectedEntries([]);
        } else {
            const allSimplified = entries.map(entry => ({
                taskID: entry.taskID,
                ledgersData: Array.isArray(entry.addedLedgers) ? entry.addedLedgers : []
            }));
            setSelectedEntries(allSimplified);
        }
    };



    const handleDisableSelected = () => {
        const entryIDsToDisable = selectedEntries.map(e => e.taskID);
        setDisableEntries(prev => [...new Set([...prev, ...entryIDsToDisable])]);
    };



    return (
        <>

            <div className={commoncss.pageLayout}>
                <Sidebar />
                <div className={`d-flex ${commoncss.pageContent}`}>
                    <motion.div
                        initial={{ x: -100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ maxHeight: "95vh", overflowY: "hidden" }} >
                        <BookcluosureNav bookClosureId={bookClosureId} setCreatePackageModal={setCreatePackageModal} setSavePresetModal={setSavePresetModal} selectedEntries={selectedEntries} entries={entries} />

                        {
                            sceLoading ? <p>Loading ....</p> :
                                bceErrorMessage ? <p className='text-danger' > {bceErrorMessage} </p> :
                                    entries && entries.length > 0 ? <>
                                        <div className={`${bookclosuretablecss.bookClosureTableContainer} m-3`}>
                                            <table className={`${bookclosuretablecss.bookClosureTable} ${bookclosuretablecss.bookclosureEntries}`}>
                                                <thead style={{ backgroundColor: "#E5E7E9" }}>
                                                    <tr>
                                                        <th className="font-inter text-center" style={{ "width": "35px", "min-width": "35px", "max-width": "35px" }}>
                                                            <input
                                                                ref={headerCheckboxRef}
                                                                type="checkbox"
                                                                title="Toggle All Rows Selected"
                                                                style={{ cursor: "pointer" }}
                                                                onChange={handleToggleAll}
                                                                checked={selectedEntries.length === entries.length}
                                                                disabled={entries.every(entry => disableEntries.includes(entry.taskID))}
                                                            />

                                                        </th>
                                                        <th className='text-left text-uppercase font-size-14 custom-font-600'>S NO</th>
                                                        <th className='text-left text-uppercase font-size-14 custom-font-600'>Ledger Code</th>
                                                        <th className='text-left text-uppercase font-size-14 custom-font-600'>Ledger Name</th>
                                                        <th className='text-right text-uppercase font-size-14 custom-font-600'>Amount</th>
                                                        <th className='text-left text-uppercase font-size-14 custom-font-600'>Preparer</th>
                                                        <th className='text-left text-uppercase font-size-14 custom-font-600'>Approver</th>
                                                        <th className='text-left text-uppercase font-size-14 custom-font-600'>remarks</th>
                                                        <th className='text-left text-uppercase font-size-14 custom-font-600'>Modules</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {entries.map((entry, ex) => (
                                                        <React.Fragment key={entry.taskID}>
                                                            {entry.addedLedgers?.map((ledger, index) => (
                                                                <React.Fragment key={ledger._id || `${entry.taskID}-${index}`}>
                                                                    <tr
                                                                        className={disableEntries.includes(entry.taskID) ? "text-muted" : ""}
                                                                    >
                                                                        {index === 0 && (
                                                                            <td
                                                                                className={`text-center ${commoncss.noBorder}  ${commoncss.vaTop}`}
                                                                                rowSpan={entry.addedLedgers.length}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    title="Toggle Row Selected"
                                                                                    className="mt-1"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onChange={() => handleEntryToggle(entry)}
                                                                                    checked={selectedEntries.some((e) => e.taskID === entry.taskID)}
                                                                                    disabled={disableEntries.includes(entry.taskID)}
                                                                                />
                                                                            </td>
                                                                        )}
                                                                        <td className={`${commoncss.noBorder}`}>{ex + 1}.{index + 1}</td>
                                                                        <td className={`text-left ${commoncss.noBorder}`}>
                                                                            <div className="font-size-14" style={{ fontWeight: "400" }}>
                                                                                {ledger.ledgerCode}
                                                                            </div>
                                                                        </td>
                                                                        <td className={`text-left ${commoncss.noBorder}`}>
                                                                            <div className="font-size-14" style={{ fontWeight: "400" }}>
                                                                                {ledger.ledgerName}
                                                                            </div>
                                                                        </td>
                                                                        <td className={`text-right ${commoncss.noBorder}`}>
                                                                            <div className="ml-3 font-size-14" style={{ fontWeight: "400" }}>
                                                                                {formatAmount(ledger.adjustmentAmount)}
                                                                            </div>
                                                                        </td>
                                                                        {/* Assignee and Approver will be displayed for the main entry */}
                                                                        {index === 0 && (
                                                                            <>
                                                                                <td className={`text-left ${commoncss.noBorder}`} rowSpan={entry.addedLedgers.length}>
                                                                                    <div className="ml-3 font-size-14" style={{ fontWeight: "400" }}>
                                                                                        {entry.assignees.map((a) => a.name).join(", ")}
                                                                                    </div>
                                                                                </td>
                                                                                <td className={`text-left ${commoncss.noBorder}`} rowSpan={entry.addedLedgers.length}>
                                                                                    <div className="ml-3 font-size-14" style={{ fontWeight: "400" }}>
                                                                                        {entry.approver?.name}
                                                                                    </div>
                                                                                </td>
                                                                                <td className={`text-left ${commoncss.noBorder}`} rowSpan={entry.addedLedgers.length}>
                                                                                    <div className="ml-3 font-size-14" style={{ fontWeight: "400" }}>
                                                                                        {entry.remarks}
                                                                                    </div>
                                                                                </td>
                                                                                <td className={`text-left ${commoncss.noBorder}`} rowSpan={entry.addedLedgers.length}>
                                                                                    <div className="d-flex w-100">
                                                                                        <p
                                                                                            className="mt-0 mb-0 font-size-14"
                                                                                            style={{ fontWeight: "600", textTransform: "uppercase" }}
                                                                                        >
                                                                                            {entry.module}
                                                                                        </p>
                                                                                    </div>
                                                                                </td>
                                                                            </>
                                                                        )}
                                                                    </tr>
                                                                    {/* Add horizontal line after the last ledger of each entry */}
                                                                    {index === entry.addedLedgers.length - 1 && ex < entries.length - 1 && (
                                                                        <tr >
                                                                            <td colSpan="9" className={commoncss.borderBottom}></td>
                                                                        </tr>
                                                                    )}
                                                                </React.Fragment>
                                                            ))}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                        : <></>
                        }

                </motion.div>
                {savePresetModal && (
                    <GetPresetNameModal
                        savePresetModal={savePresetModal}
                        setSavePresetModal={setSavePresetModal}
                        SaveAsPreset={SaveAsPreset}
                        isSavePresetLoading={isSavePresetLoading}
                        name={name}
                        setName={setName}
                    />
                )}

                {createPackageModal && (
                    <CreatePackageModal
                        setCreatePackageModal={setCreatePackageModal}
                        companyId={companyId}
                        workspaceId={workspaceId}
                        selectedEntries={selectedEntries}
                        handleDisableSelected={handleDisableSelected}
                    />
                )}
            </div>
        </div >
        </>
    );
}

export default BookClosureEntries;
